<eds-simple-modal
  *ngIf="(isVisible$ | async) === true"
  [config]="modalConfig"
  [modalId]="'subscriptionsPreferencesModal'"
  [showModal]="true"
  [showClose]="true"
  [disableCloseOnBackground]="true"
  (onClose)="onModalClose()"
>
  <div modal-body class="preferences-modal__body">
    <div
      class="preferences-modal__get-started"
      *ngIf="getStarted"
      [innerHTML]="
        'subscriptions.preferences-start-message' | translate | safeHtml
      "
    ></div>
    <div>&nbsp;</div>
    <div
      class="preferences-modal__body-loader"
      *ngIf="isLoading && !getStarted"
    >
      <eds-progress-spinner
        [isHide]="false"
        [ifLoadingText]="true"
        size="medium"
        [loadingText]="'subscriptions.fetching-preferences' | translate"
        spinnerName="FundDocumentsLoadingSpinner"
      ></eds-progress-spinner>
    </div>
    <div *ngIf="!isLoading && !getStarted">
      <eds-progress-stepper
        [current]="currentConfigStep"
        [stepInfo]="configSteps"
        (stepSelected)="stepSelected($event)"
      ></eds-progress-stepper>
      <div *ngIf="currentConfigStep < configSteps.length - 1">
        <div
          edsRow
          class="preferences-modal__body-subtitle"
          [innerHTML]="
            ('subscriptions.chose' | translate) +
            ' ' +
            configSteps[currentConfigStep]
          "
        ></div>
        <div
          edsRow
          class="preferences-modal__body-text"
          [innerHTML]="
            ('subscriptions.select-your-preferred' | translate) +
            ' ' +
            configSteps[currentConfigStep]
          "
        ></div>
        <div edsRow>
          <ng-container
            [ngTemplateOutlet]="chipsSelection"
            [ngTemplateOutletContext]="{
              selector: selectors[currentConfigStep]
            }"
          ></ng-container>
        </div>
      </div>
      <div *ngIf="currentConfigStep === configSteps.length - 1">
        <div *ngFor="let group of selectedItems; let i = index">
          <div
            *ngIf="group.length > 0"
            edsRow
            class="preferences-modal__body-subtitle"
            [innerHTML]="configSteps[i]"
          ></div>
          <div class="preferences-modal__body-subtitle-spacing"></div>
          <div *ngIf="group.length > 0" edsRow>
            <ng-container
              [ngTemplateOutlet]="chipsSelection"
              [ngTemplateOutletContext]="{
                selector: selectedItems[i]
              }"
            ></ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div modal-footer class="preferences-modal__footer">
    <button
      id="btnSubsProductClose"
      class="ft__btn"
      edsButton="secondary"
      size="normal"
      (click)="currentConfigStep === 0 ? onModalClose() : previousStep()"
      data-analytics-no-event="true"
    >
      <span
        class="ft__btn__txt"
        [innerHTML]="
          currentConfigStep === 0
            ? ('subscriptions.close-modal' | translate)
            : ('subscriptions.previous-step' | translate)
        "
      ></span>
    </button>
    <button
      id="btnSubsProductStart"
      class="ft__btn preferences-modal__footer-button-right"
      edsButton="primary"
      size="normal"
      *ngIf="getStarted"
      [noMargin]="true"
      (click)="startPreferences()"
      data-analytics-no-event="true"
    >
      <span
        class="ft__btn__txt"
        [innerHTML]="'subscriptions.get-started' | translate"
      ></span>
    </button>
    <button
      id="btnSubsProductSave"
      class="ft__btn preferences-modal__footer-button-right"
      edsButton="primary"
      size="normal"
      *ngIf="!isLoading && !getStarted"
      [noMargin]="true"
      (click)="
        currentConfigStep === configSteps.length - 1
          ? updatePreferences()
          : nextStep()
      "
      data-analytics-no-event="true"
    >
      <span
        class="ft__btn__txt"
        [innerHTML]="
          currentConfigStep === configSteps.length - 1
            ? ('subscriptions.submit-modal' | translate)
            : ('subscriptions.next-step' | translate)
        "
      ></span>
    </button>
  </div>
</eds-simple-modal>
<ng-template
  #chipsSelection
  let-selector="selector"
  let-callback="changeSelection"
>
  <eds-chips
    *ngFor="let docTypeChip of selector"
    [id]="docTypeChip.id"
    [chips]="docTypeChip.chips"
    [checked]="docTypeChip.selected"
    (click)="changeSelection($event, selector)"
    class="preferences-modal__body-chips"
  ></eds-chips>
</ng-template>
